export const GIT_REV = "f676f90e";
